<template>
  <v-form ref="formFiltro">
    <v-card class="px-6 py-3 br-15 w-100" elevation="0">
      <v-row>
        <v-col class="d-flex" cols="3">
          <v-toolbar-title class="page-title">Calculadora </v-toolbar-title>
          <div class="ma-1">
            <InfoBox expands>
              <p>
                A calculadora apresentará, por fornecedor, as ativações com as respectivas quantidades negociadas no plano/pacote, 
                confrontando-as com os valores efetivamente utilizados e com o saldo ainda disponível para programação.              
              </p>

              <p>
                <b>Atenção:</b> ao selecionar o ano, o sistema considerará <b>Abril</b> como mês inicial e <b>Março</b> do ano seguinte como mês final, 
                alinhado ao calendário de planejamento anual da RD. 
              </p>

              <p>
                Exemplo: ao selecionar o ano <b>2024</b>, o sistema considerará o período de <b>abril/2024 a março/2025</b>.
              </p>
            </InfoBox>
          </div>
        </v-col>
        <v-col cols="3" class="pb-0">
          <AnoInput
            label="Ano"
            v-model="filtro.ano"
            :rules="usuarioTipo == 'fornecedor' && regra.mesInicial"
            :max="filtroMesMaximo"
          />
        </v-col>
        <v-col cols="3" class="pb-0">
          <v-autocomplete
            label="Fornecedor"
            v-model="filtro.id_fornecedor"
            :items="lista.fornecedor"
            :rules="regra.fornecedor"
            outlined
            dense
            class="input-cinza"
            :menu-props="menuProps"
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <div
                v-if="filtro.id_fornecedor.length === 1 && index === 0"
                class="autocomplete-selecao"
              >
                {{ item.text }}
              </div>
              <span
                v-if="filtro.id_fornecedor.length > 1 && index === 0"
                class="grey--text caption mr-1"
                >{{ filtro.id_fornecedor.length }} selecionados</span
              >
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3" class="pb-0">
          <v-autocomplete
            label="Ativação"
            v-model="filtro.id_ativacao"
            :items="lista.ativacao"
            outlined
            dense
            class="input-cinza"
            :menu-props="menuProps"
            multiple
            clearable
          >
            <template v-slot:selection="{ item, index }">
              <div
                v-if="filtro.id_ativacao.length === 1 && index === 0"
                class="autocomplete-selecao"
              >
                {{ item.text }}
              </div>
              <span
                v-if="filtro.id_ativacao.length > 1 && index === 0"
                class="grey--text caption mr-1"
                >{{ filtro.id_ativacao.length }} selecionados</span
              >
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-divider class="mt-n1 mb-2"></v-divider>

      <v-row>
        <v-col cols="6" class="px-3 ml-auto pb-3" align="end">
          <v-btn
            class="ml-4 px-8 new-button"
            color="yellow"
            dark
            @click="limpar()"
          >
            <v-icon left>mdi-filter-off</v-icon> Limpar
          </v-btn>
          <v-btn
            class="ml-5 px-8 new-button"
            color="primary"
            @click="filtrar()"
          >
            <v-icon left>mdi-filter</v-icon> Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-overlay :value="overlay" :z-index="300">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-form>
</template>

<script>
import InfoBox from "../../../components/InfoBox.vue";
import AnoInput from "../../../components/AnoInput.vue";
import useFiltros from "../../../hooks/useFiltros";

export default {
  setup() {
    const {
      isLoading,
      isError,
      isFetching,
      lista,
      error,
      refetch,
    } = useFiltros("/planejamentoEcommerce/calculadora/filtros");

    return { isLoading, isError, isFetching, lista, error, refetch };
  },
  components: {
    AnoInput,
    InfoBox,
  },
  data() {
    return {
      menuProps: {
        bottom: true,
        offsetY: true,
        contentClass: "select-outline",
        transition: "slide-y-transition",
      },
      mostrarFiltros: null,
      filtro: {},
      regra: {
        mesInicial: [
          (v) => !!v || "Selecione um período inicial para o filtro",
        ],
        mesFinal: [
          (v) => !!v || "Selecione um período final para o filtro",
          (v) =>
            (!!v && v >= this.filtro.mesInicial) ||
            "O período final deve ser igual ou posterior ao período inicial",
        ],
        fornecedor: [(v) => !!v || "O campo fornecedor é obrigatório"],
      },
      filtroInicializado: false,
    };
  },
  beforeMount() {
    this.iniciaFiltro();
  },
  mounted() {
    this.verificarEExecutarFiltroInicial();
  },
  computed: {
    overlay() {
      return Object.keys(this.lista).length === 0 && this.isFetching;
    },
    usuarioTipo() {
      if (this.$store.getters.getUsuario.id_fornecedor) {
        return "fornecedor";
      }
      return "rd";
    },
    filtroMesMaximo() {
      if (this.usuarioTipo === "fornecedor") {
        return this.$moment().format("YYYY-MM");
      }
      return null;
    },
    dadosCarregados() {
      return !this.isLoading && !this.isFetching && Object.keys(this.lista).length > 0;
    },
  },

  methods: {
    iniciaFiltro() {
      this.filtro = {
        id_fornecedor: [],
        id_ativacao: [],
        ano: this.$moment().format("YYYY"),
      };

      if (this.usuarioTipo === "fornecedor") {
        this.filtro.mesInicial = this.$moment().format("YYYY");

        if (this.lista.fornecedor && this.lista.fornecedor.length === 1) {
          this.filtro.id_fornecedor = [this.lista.fornecedor[0].value];
        }
      }

      this.resetValidation();
    },
    limpar() {
      this.iniciaFiltro();
    },
    filtrar() {
      if (!this.validate()) return;

      this.$emit("filtrar");
    },
    validate() {
      return this.$refs.formFiltro.validate();
    },
    resetValidation() {
      this.$refs.formFiltro?.resetValidation();
    },
    verificarEExecutarFiltroInicial() {
      if (this.dadosCarregados && !this.filtroInicializado) {
        this.executarFiltroInicial();
      }
    },
    executarFiltroInicial() {
      this.$nextTick(() => {
        if (this.validate()) {
          this.filtroInicializado = true;
          this.$emit("filtrar");
        }
      });
    },
  },
  watch: {
    "lista.fornecedor": function() {
      if (this.usuarioTipo === "fornecedor" && this.filtro.id_fornecedor.length === 0) {
        this.iniciaFiltro();
      }
    },
    dadosCarregados: function(novoValor) {
      if (novoValor && !this.filtroInicializado) {
        this.executarFiltroInicial();
      }
    },
    usuarioTipo: function() {
      this.iniciaFiltro();
      if (this.dadosCarregados) {
        this.filtroInicializado = false;
        this.executarFiltroInicial();
      }
    }
  },
};
</script>